export default __webpack_public_path__ + "static/media/rotilogo.a9bc56c4.gif";